export default {
    en: {
        search: 'Search',
        name: 'Product Name',
        design: 'Design',
        size: 'Size',
        quality: 'Quality',
        brand: 'Brand'
    },
    uz: {
        search: 'Izlash',
        name: 'Mahsulot Nomi',
        design: 'Dizayn',
        size: "O'lchami",
        quality: 'Sifati',
        brand: 'Brand'
    },
    ru: {
        search: 'Поиск',
        name: 'Название продукта',
        design: 'Дизайн',
        size: 'Размер',
        quality: 'Сорт',
        brand: 'Марка'
    }
}